import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Tailwind class merger. Use instead of raw template literals. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTime(unix?: number | null) {
  if (!unix) return '-'
  return new Date(unix * 1000).toLocaleString('ko-KR')
}
